import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchJobOrder } from "./jobOrderFunctions";
import ListDataJobOrder from "./ListDataJobOrder";

export default function ProjectJobOrder() {
  const { projectId } = useParams();
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [jobOrderData, setJobOrderData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchJobOrder(projectId, setJobOrderData, setLoading, dispatch);
  }, []);
  return (
    <div className="w-full p-2">
      <ListDataJobOrder
        jobOrderData={jobOrderData}
        loading={loading}
        titles={[
          "S.NO.",
          "JOB ENQUIRY NO",
          "REC. AGENCY JOB ENQ NO",
          "NATIONALITY",
          "TOTAL QUANTITY",
          "JOB ASSIGNED TO",
          "ACTION",
        ]}
      />
    </div>
  );
}
